import { useMutation, useQueryClient } from "@tanstack/react-query";
import * as queries from '@supabase/queries';

export function useSetupAccount() {
    const queryClient = useQueryClient();

    return useMutation({
        mutationKey: ["userData--update"],
        mutationFn: async (data: {
            password: string, 
            first_name: string,
            last_name: string
        }) => {
            const res = await queries.setupAccount(data);
            return res;
        },
        onSuccess: () => {
            queryClient.invalidateQueries({queryKey: ["userData"]});
        }
    });
}
